import RedoSquareIcon from "@redotech/redo-icons/redo-square.svg";
import ShopifyIcon from "@redotech/redo-icons/shopify_glyph_black.svg";
import {
  FIRST_INSTALL_ATTRIBUTION_SOURCE_LABELS,
  type FirstInstallAttributionSource,
} from "@redotech/redo-model/onboarding";
import {
  BookOpen,
  Calendar,
  Instagram,
  Linkedin,
  Podcast,
  Search,
  Shapes,
  Users,
  Youtube,
} from "lucide-react";
import type { IntakeQuestion } from "../../registry/types";

type ReclaimAttributionOptionConfig = Pick<
  IntakeQuestion["options"][number],
  "Icon"
> & { value: FirstInstallAttributionSource };

const RECLAIM_ATTRIBUTION_OPTION_CONFIGS = [
  { value: "search", Icon: Search },
  { value: "shopify_app_store", Icon: ShopifyIcon },
  { value: "linkedin", Icon: Linkedin },
  { value: "youtube", Icon: Youtube },
  { value: "social", Icon: Instagram },
  { value: "podcast", Icon: Podcast },
  { value: "article", Icon: BookOpen },
  { value: "referral", Icon: Users },
  { value: "event", Icon: Calendar },
  { value: "existing_redo", Icon: RedoSquareIcon },
  { value: "other", Icon: Shapes },
] as const satisfies readonly ReclaimAttributionOptionConfig[];

export const RECLAIM_ATTRIBUTION_OPTIONS =
  RECLAIM_ATTRIBUTION_OPTION_CONFIGS.map((option) => ({
    ...option,
    label: FIRST_INSTALL_ATTRIBUTION_SOURCE_LABELS[option.value],
  })) satisfies (IntakeQuestion["options"][number] & {
    value: FirstInstallAttributionSource;
  })[];

export const RECLAIM_ATTRIBUTION_QUESTION = {
  id: "attribution_source",
  type: "single-select",
  prompt: "Where did you hear about us?",
  required: true,
  layout: "grid",
  options: RECLAIM_ATTRIBUTION_OPTIONS,
} satisfies IntakeQuestion;
